<div *commonUiOptionalWizardStep id="bankverbindungAngaben">

  <div class="mb-5x">
    <h2>{{ 'COMMON_UI.FRAGEBOGEN.BANKVERBINDUNGEN.TITEL' | translate }}</h2>

    <div class="col-sm-12 col-lg-12 p-0 mt-2x">
      <common-ui-card [message]=" 'COMMON_UI.FRAGEBOGEN.BANKVERBINDUNGEN.INFO' | translate"
                      type="info">
      </common-ui-card>
    </div>

    <div *ngIf="hinweisAnzeigen" class="col-sm-12 col-lg-12 p-0">
      <common-ui-card [message]=" 'COMMON_UI.FRAGEBOGEN.BANKVERBINDUNGEN.HINWEIS' | translate"
                      type="info">
      </common-ui-card>
    </div>

    <div class="mb-5x">
      <div class="d-flex justify-content-end mb-3x">
        <common-ui-daten-uebernahme (picked)="data.bankverbindung = $event"
                                    *ngIf="stammdatenArray.length != 0"
                                    [itemTemplate]="datenuebernahmeBankverbindung"
                                    [items]="stammdatenArray" [readonly]="readonly"
                                    context="Bankverbindung"></common-ui-daten-uebernahme>
      </div>
      <common-ui-bankverbindung [(data)]="data.bankverbindung"
                                [index]="0" [readonly]="readonly">
      </common-ui-bankverbindung>
    </div>

  </div>

</div>

<ng-template #datenuebernahmeBankverbindung let-item="item">
  <h4 class="list-group-item-heading">{{item?.iban}}</h4>
  <div class="list-group-item-text">
    <p *ngIf="item?.bic">{{item?.bic}}</p>
    <p *ngIf="item?.abweichenderKontoinhaber">{{ 'COMMON_UI.BANKVERBINDUNG.ABWEICHENDER_KONTOINHABER' | translate }}:
      {{item?.abweichenderKontoinhaber}}</p>
    <p *ngIf="item?.bezeichnung">{{item?.bezeichnung}}</p>
  </div>
</ng-template>
